export default __webpack_public_path__ + "static/media/shield.986b2d87.svg";